<template>
    <v-dialog v-model="dialog" persistent width="700">
        <v-card :loading="loading" v-if="!!popup">
            <v-card-title class="h3 arFont">
                {{ popup.title }}
            </v-card-title>
            <v-card-text class="pt-2">
                <div class="arFont">
                    {{ popup.body }}
                </div>
                <v-row>
                    <v-spacer></v-spacer>
                    <v-col cols="10">
                        <v-img :src="popup.image"></v-img>
                    </v-col>
                    <v-spacer></v-spacer>
                </v-row>
                <a :href="popup.link" target="_blank">{{ popup.link }}</a>
            </v-card-text>
            <v-card-actions>
                <v-btn :loading="loading" text color="error" @click.prevent="dismiss" class="arFont">{{ i18n["ignore"] }}</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    props: ['popup', 'loading'],
    computed: {
        dialog: {
            get() {
                return !!this.popup
            },
        },
        language() {
            return this.$store.state.language
        },
        globalLoading() {
            return this.$store.state.globalLoading
        },
        user() {
            return this.$store.state.user
        },
        online() {
            return this.$store.state.online
        },
        i18n() {
            return this.$store.state.i18n[this.$store.state.language]
        },
        arabic() {
            if (this.$store.state.language == 'ar') return true
        },
    },
    methods: {
        dismiss() {
            this.$emit('dismissPopup', this.popup)
        }
    },
}
</script>